<template>
  <div>
    <ZZDownload v-if="isZZ" />
    <ZLJDownload v-else-if="isZlj" />
    <WxMini v-else-if="isWXMini" />
    <ChxDownload v-else-if="isChx" />
    <!-- 其他app配置，默认是转转 -->
    <ZZDownload v-else />
  </div>
</template>

<script>
// @ is an alias to /src
import ZZDownload from './ZZDownload.vue'
import ZLJDownload from './ZLJDownload.vue'
import ChxDownload from './ChxDownload.vue'
import WxMini from './WXMini.vue'
// 后续有时间 可以把组件合并成一个
import { isZZDownload, isZljDownload, isChxDownload, isWXMini } from '../utils/index.js'

export default {
  name: 'Download',
  components: { ZZDownload, ZLJDownload, ChxDownload, WxMini },
  created() {
    console.log(location.pathname)
    this.isZZ = isZZDownload
    this.isZlj = isZljDownload
    this.isChx = isChxDownload
    this.isWXMini = isWXMini
  },
  data() {
    return {
      isZZ: false,
      isZlj: false,
      isChx: false,
      isWXMini: false,
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
